module.exports = __webpack_public_path__ + "static/media/logo.7f6c1b53.png";